<script lang="ts">
	import Button from '#lib/atoms/Button.svelte'
	import Dialog from '#lib/atoms/Dialog.svelte'
	import IconWarn from '$svg/icon-warning.svg?component'
	import { t } from '$i18n/i18n'

	let dialog: Dialog
	let onConfirm: () => void
	let tagLabel: string = $state('')

	export function open(confirm: () => void, label: string) {
		onConfirm = confirm
		tagLabel = label
		dialog.open()
	}

	function confirm() {
		onConfirm()
		dialog.close()
	}
</script>

<Dialog bind:this={dialog} style="gap: 30px; align-items: center">
	<div class="delete-tag__circle">
		<IconWarn width="50px" height="50px" fill="var(--color-red-500)" />
	</div>
	<div class="delete-tag__text">
		<h1>{`${tagLabel}	${$t('UI.tags.dialog.delete.title')}`}</h1>
	</div>
	<div class="delete-tag__buttons">
		<Button variant="secondary" color="white" style="width: 100%" onclick={() => dialog.close()}
			>{$t('Button.cancel')}</Button
		>
		<Button variant="primary" color="red" style="width: 100%" onclick={confirm}
			>{$t('UI.delete')}</Button
		>
	</div>
</Dialog>

<style>
	.delete-tag__circle {
		width: 95px;
		height: 95px;
		background: var(--color-red-50);
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-top: 14px;
	}

	.delete-tag__text {
		text-align: center;

		& > h1 {
			margin-bottom: 10px;
		}
	}

	.delete-tag__buttons {
		display: flex;
		gap: 10px;
		width: 100%;
	}
</style>
